const LayoutWrapper:React.FC<{children:React.ReactNode}> = ({children}) => {
    return (
        <>
            <div className="row" style={{marginLeft: 0, marginRight: 0}}>
                   {children}
            </div>
        </>
    )
}
export default LayoutWrapper;